import React, { Component } from "react";

import { checkParams } from "./../../components/Utils";

import StepColorSliderHandle from "./StepColorSliderHandle";
import StepColorPrimary from "./StepColorSlider/StepColorPrimary";
import StepColorSecondary from "./StepColorSlider/StepColorSecondary";
import StepColorTertiary from "./StepColorSlider/StepColorTertiary";
import Slider from "react-slick";

import LookAndFeelLabial from "./LookAndFeel/LookAndFeelLabial";
import LookAndFeelLips from "./LookAndFeel/LookAndFeelLips";

import { newSearchURL, Event } from "./../Utils";
import Features from "./../layout/Features";

import Footer from "./../layout/Footer";

export class StepColor extends Component {
  handleStepParam = stepParamURL => {
    const { history, location } = this.props;
    const { pathname } = location;

    const checkIfParamExist =
      location && checkParams(`step${parseInt(stepParamURL) + 1}`, location);

    const newURL = newSearchURL(
      `step=${stepParamURL}`,
      `step=${parseInt(stepParamURL) + 1}`,
      location
    );

    let nextStep = `${pathname}${newURL}`;
    if (!checkIfParamExist) {
      nextStep = `${pathname}${newURL}&step${parseInt(stepParamURL) + 1}=empty`;
    }

    history.push(nextStep);
  };

  render() {
    let settings = {
      arrows: false,
      dots: true,
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      fade: true,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            arrows: true,
            dots: false
          }
        }
      ]
    };

    const { match, history, location, stepIndex } = this.props;
    const stepParamURL = location && checkParams("step", location);

    return (
      <div data-test="StepColorComponent">
        <StepColorSliderHandle
          match={match}
          history={history}
          location={location}
        >
          {(
            state,
            props,
            setPrimaryColor,
            setSecondaryColor,
            setTertiaryColor
          ) => {
            return (
              <div
                className={`stepColorWrap ${
                  stepIndex === 0 ? "row mg-left-0 mg-right-0" : ""
                }`}
              >
                <div className={stepIndex === 0 ? "col-12 col-md-6 p-0" : ""}>
                  <div style={{ position: "relative", zIndex: "1"}}>
                  <div className="fixed-side">

                      <div className="FooterWrap">
                        <Footer location={location} history={history} />
                      </div>
                      <Slider {...settings}>
                        <div>
                          <LookAndFeelLabial state={state} location={location} />
                        </div>
                    </Slider>
                  </div>
                  </div>
                </div>

                <div
                  className={
                    stepIndex === 0
                      ? "col-12 col-md-6 wizard-col-steps socket-holder"
                      : ""
                  }
                >
                  {stepParamURL === "1" && (
                    <div>
                      <StepColorPrimary
                        state={state}
                        props={props}
                        setPrimaryColor={setPrimaryColor}
                        setSecondaryColor={setSecondaryColor}
                      />
                      {state && state.colorsSecondary && (
                        <StepColorSecondary
                          state={state}
                          props={props}
                          setPrimaryColor={setPrimaryColor}
                          setSecondaryColor={setSecondaryColor}
                        />
                      )}

                      {state.colorsTertiary &&
                        state.colorsTertiary.length > 0 && (
                          <StepColorTertiary
                            colors={state.colorsTertiary}
                            state={state}
                            props={props}
                            setTertiaryColor={setTertiaryColor}
                          />
                        )}
                    </div>
                  )}
                  {stepIndex === 0 && (
                    /**
                     * Only apply for step colors
                     */
                    <div>
                      <div className="mt-md-5">
                        {stepParamURL && (
                            <button
                            type="button"
                            className="d-md-none d-xs-block w-100 btn btn-red btn-next-step d-none d-md-block w-100"
                            onClick={() => this.handleStepParam(stepParamURL)}
                            >
                                {/*<div className="mt-1 mr-2">
                                 Ir a<br /> paso
                                 </div>
                                 <div className="font-size-15">
                                 {parseInt(stepParamURL) + 1}{" "}
                                 <span className="font-size-8 font-weight-lighter">
                                 ❯
                                 </span>
                                 </div>*/}
                            Paso siguiente
                            </button>
                        )}

                        {stepParamURL && (
                          <button
                            type="button"
                            className="d-md-none d-xs-block w-100 btn btn-red btn-next-step button-next-xs"
                            onClick={() => this.handleStepParam(stepParamURL)}
                          >
                            Paso siguiente
                          </button>
                        )}
                      </div>
                      <Features route={this.props} />
                    </div>
                  )}
                </div>
              </div>
            );
          }}
        </StepColorSliderHandle>
      </div>
    );
  }
}

export default StepColor;
